import { OnePlusManyInstanceId } from 'constants/bodyBlocks';
import { StoreBodyBlock } from 'constants/enums';
import { v4 } from 'uuid';

import { IOnePlusManyInstanceConfig } from 'common/contracts';
import { EBlockType } from 'common/TemplateStudio.types';
import { buyOneGetManyDesigns } from 'components/TemplatesStudio/DesignsMetadata/buyOneGetMany.metadata';
import { ETemplateStudioLayoutOptions } from 'components/TemplatesStudio/enums';

import {
  IMultiInstanceBlockDescriptor,
  IOnePlusManyFormStoreBlock
} from './multiInstanceBlocks.types';

export const buildDefaultOnePlusManyInstance =
  (): IOnePlusManyInstanceConfig => ({
    desktopLayout: ETemplateStudioLayoutOptions.VERTICAL,
    themes: [],
    selectedDesignId: buyOneGetManyDesigns.defaultBuyOneGetMany.id,
    maxOffers: { unlimited: true, value: 10 },
    rewardsLayout: 3
  });

export const buildDefaultOnePlusManyFormStoreBlock = (
  instanceKey: OnePlusManyInstanceId
): IOnePlusManyFormStoreBlock => ({
  id: `bb-${instanceKey}-${v4()}`,
  instanceKey,
  type: EBlockType.ONE_PLUS_MANY,
  isVisible: true,
  ...buildDefaultOnePlusManyInstance()
});

const onePlusManyDescriptor: IMultiInstanceBlockDescriptor = {
  block: StoreBodyBlock.onePlusMany,
  buildDefaultInstance: buildDefaultOnePlusManyInstance,
  modalRow: {
    sectionLabel: '1+Many',
    rowTitle: 'Add 1+Many',
    rowDescription: 'Surface a 1+Many offer block.'
  }
};

export const MULTI_INSTANCE_BLOCKS: ReadonlyArray<IMultiInstanceBlockDescriptor> =
  [onePlusManyDescriptor];

export const MULTI_INSTANCE_BLOCK_BY_BLOCK: ReadonlyMap<
  StoreBodyBlock,
  IMultiInstanceBlockDescriptor
> = new Map(
  MULTI_INSTANCE_BLOCKS.map((descriptor) => [descriptor.block, descriptor])
);

export const MULTI_INSTANCE_REGISTERED_BLOCKS: ReadonlyArray<StoreBodyBlock> =
  MULTI_INSTANCE_BLOCKS.map((descriptor) => descriptor.block);

export const getMultiInstanceDescriptor = (
  block: StoreBodyBlock
): IMultiInstanceBlockDescriptor | undefined =>
  MULTI_INSTANCE_BLOCK_BY_BLOCK.get(block);

export const isMultiInstanceBlock = (block: StoreBodyBlock): boolean =>
  MULTI_INSTANCE_BLOCK_BY_BLOCK.has(block);
